<template>
  <div id="app">
    <router-view/>
    <app-quick-contact/>
    <app-copyright/>
  </div>
</template>

<script>
  import AppCopyright from '@/components/Copyright'
  import AppQuickContact from '@/components/QuickContact'

  export default {
    components: { AppQuickContact, AppCopyright }
  }
</script>

<style lang="scss" scoped>
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100%;
    @media screen and (max-width: 680px) {
      display: block;
    }
  }
</style>
